import { MainLayout } from '@/components';
import { Spinner } from '@/components/Spinner';
// import { useAuthInfo } from '@/features';
import { lazyImport } from '@/utils';
import { Suspense } from 'react';
import {
  //  Navigate,
   Outlet, 
  //  useLocation 
  } from 'react-router-dom';

const { ReservationPageRoutes } = lazyImport(() => import('@/features/main'), 'ReservationPageRoutes');
const { ReservationListPageRoutes } = lazyImport(() => import('@/features/list'), 'ReservationListPageRoutes');
const { AdmingPageRoutes } = lazyImport(() => import('@/features/admin'), 'AdmingPageRoutes');
const { NotFound } = lazyImport(() => import('@/features/notFound'), 'NotFound');

export function Protected() {
  // const { authInfo } = useAuthInfo();
  // const client_id = authInfo?.username;

  function Protected() {
    // const location = useLocation();

    // if (!client_id) {
    //   return <Navigate to="/" state={{ redirect: location.pathname }} />;
    // }

    return (
      <MainLayout>
        <Suspense fallback={<Spinner />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    );
  }
 const ProtectedRoutes = [
  {
    path: '/main',
    element: <Protected />,
    children: [
      {
        path: '',
        element: <ReservationPageRoutes />,
      },
    ],
  },
  {
    path: '/list',
    element: <Protected />,
    children: [
      {
        path: '',
        element: <ReservationListPageRoutes />,
      },
    ],
  },
  {
    path: '/admin',
    element: <Protected />,
    children: [
      {
        path: '',
        element: <AdmingPageRoutes />,
      },
    ],
  },
  {
    path: '*',
    element: <Protected />,
    children: [
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
];

return { ProtectedRoutes };
}
